<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <div class="d-flex flex-wrap align-items-baseline w-100 py-3 mb-2 head-bar">
      <h4 class="font-weight-bold">Bookings</h4>
    </div>
    <b-card no-body>
      <b-tabs card v-model="tabIndex">
        <b-tab title="Bookings">
          <BookingsListTab @query-change="remember('bookings', $event)" />
        </b-tab>
        <b-tab title="Free Desks">
          <FreeDesksTab @query-change="remember('free', $event)" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import BookingsListTab from '@/components/bookings/BookingsListTab.vue'
import FreeDesksTab from '@/components/bookings/FreeDesksTab.vue'
import { sameQuery } from '@/components/bookings/utils'

// ?tab= names the tab rather than numbering it: a link written elsewhere should not break
// when a tab is inserted before the one it meant
const TABS = ['bookings', 'free']

export default {
  name: 'Bookings',
  components: { BookingsListTab, FreeDesksTab },
  data() {
    return {
      tabIndex: Math.max(TABS.indexOf(this.$route.query.tab), 0),
      // each tab's filters as it would write them into the address, by tab name
      tabQueries: {}
    }
  },
  methods: {
    // Both tabs stay mounted and read the same floor/since/until, so they cannot both write
    // them: each reports its own, and the address carries the ones on the tab in front.
    remember(tab, query) {
      this.$set(this.tabQueries, tab, query)
      if (tab === TABS[this.tabIndex]) this.sync()
    },
    // the address keeps up with the screen, so it can be linked to, shared and reloaded
    // where the reader left it
    sync() {
      const tab = TABS[this.tabIndex]
      const query = { ...(this.tabQueries[tab] || {}) }
      // the first tab is what a bare /bookings opens on anyway
      if (tab !== TABS[0]) query.tab = tab
      if (sameQuery(query, this.$route.query)) return

      // replace, not push: moving a filter is not a page the back button should step through
      this.$router.replace({ query }).catch(() => {})
    }
  },
  watch: {
    tabIndex() {
      this.sync()
    },
    // a link to the other tab while this screen is open (the sidebar's bare /bookings, back
    // to an address from /home) reuses the screen rather than building it again
    '$route.query.tab'(tab) {
      this.tabIndex = Math.max(TABS.indexOf(tab), 0)
    }
  }
}
</script>
